export default __webpack_public_path__ + "static/media/ecom1.a9439564.jpeg";